import { render, staticRenderFns } from "./ToastificationContent.vue?vue&type=template&id=20a2843e&scoped=true"
import script from "./ToastificationContent.vue?vue&type=script&lang=js"
export * from "./ToastificationContent.vue?vue&type=script&lang=js"
import style0 from "./ToastificationContent.vue?vue&type=style&index=0&id=20a2843e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2843e",
  null
  
)

export default component.exports